import styles from "./addArticle.module.css";
import { Link, useHistory } from "react-router-dom";
import { Typography, Box, Button, Checkbox, Chip, FormControl, InputLabel, ListItemText, MenuItem, OutlinedInput, Select, TextField, Slide, IconButton } from "@mui/material";
import { ArrowLeft, Home, UploadCloud, X } from "react-feather";
import { toast } from 'react-smart-toaster';
import { useAuth0 } from "@auth0/auth0-react";
import { AddLogCallAPI } from "../../../../components/AddLogs";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import axios from 'axios';
import { useEffect, useRef, useState } from "react";
import { Editor } from "@tinymce/tinymce-react";
import { Snackbar } from "@material-ui/core";
import Loader from "../../../../components/Loader";
import { Helmet } from "react-helmet";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
}

const schema = yup.object().shape({
    is_published: yup.string().required('This field is Required'),
    title: yup.string().required('This field is Required'),
    category_ids: yup.array().required("This field is Required").nullable(),
    property_ids: yup.array().required("This field is Required").nullable(),
    description: yup.string().required("This field is Required"),
    thumbnail_type: yup.string(),
    video_url: yup.string().when('thumbnail_type', (thumbnail_type) => {
        if (thumbnail_type && (thumbnail_type === "video")) return yup.string().required('This field is Required');
        return yup.string();
    }),
    image_url: yup.string().when('thumbnail_type', (thumbnail_type) => {
        if (thumbnail_type && (thumbnail_type === "image")) return yup.string().required('This field is Required');
        return yup.string();
    })
});

const AddArticle = ({ history, match }) => {
    const { getAccessTokenSilently } = useAuth0();
    const { id } = match.params;
    const redirect = useHistory();
    const [loading, setLoading] = useState(false);
    const [propertyList, setPropertyList] = useState([]);
    const [categoryList, setCategoryList] = useState([]);
    const [selectedProperties, setSelectedProperties] = useState([]);
    const [selectedCategories, setSelectedCategories] = useState([]);
    const [thumbnailType, setThumbnailType] = useState();
    const [thumbnailTemp, setThumbnailTemp] = useState(null);
    const [thumbnailTempURL, setThumbnailTempURL] = useState("");
    const [thumbnailURL, setThumbnailURL] = useState("");
    const [isPublished, setIsPublished] = useState(0);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMsg, setSnackbarMsg] = useState("");
    const editorRef = useRef(null);

    const { register, handleSubmit, control, errors, setValue, clearErrors } = useForm({
        resolver: yupResolver(schema),
        mode: 'onChange',
        defaultValues: {
            title: '',
            video_url: '',
            thumbnail_type: '',
            category_ids: [],
            property_ids: [],
            is_published: 0
        }
    });

    useEffect(() => {
        const getPropertyList = async () => {
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

            axios(process.env.REACT_APP_RESOURCE_API_URL + "v1/property-list", {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }).then((response) => {
                setPropertyList(response.data.data);
            }).catch(() => {
                setPropertyList([]);
            });
        }

        getPropertyList();
    }, [getAccessTokenSilently]);

    useEffect(() => {
        const getCategoryList = async () => {
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

            axios(process.env.REACT_APP_RESOURCE_API_URL + "v1/article-category-list", {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }).then((response) => {
                setCategoryList(response.data.data);
            }).catch(() => {
                setCategoryList([]);
            });
        }

        getCategoryList();
    }, [getAccessTokenSilently]);

    useEffect(() => {
        const getDetails = async () => {
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

            axios(process.env.REACT_APP_RESOURCE_API_URL + "v1/articles/" + id, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }).then((response) => {
                let responseData = response.data.data;

                setValue('title', responseData?.title);
                setValue('description', responseData?.description);
                setValue('category_ids', responseData?.category_id_arr);
                setValue('property_ids', responseData?.property_id_arr);
                setValue('thumbnail_type', responseData?.thumbnail_type);
                setValue('is_published', responseData?.is_published);
                setSelectedCategories(responseData?.category_id_arr);
                setSelectedProperties(responseData?.property_id_arr);

                setThumbnailType(responseData?.thumbnail_type);
                setThumbnailURL(responseData?.thumbnail_url);
                setIsPublished(responseData?.is_published);

                setTimeout(() => {
                    setValue('video_url', responseData?.video_url);
                    setValue('image_url', responseData?.thumbnail_name);
                }, 500);
            });
        }

        if (id) {
            getDetails();
        }
    }, [id, getAccessTokenSilently, setValue]);

    const get_youtube_thumbnail = (url) => {
        if (url) {
            var video_id, thumbnail, result;
            if (url.match(/youtube\.com.*(\?v=|\/embed\/)(.{11})/)) {
                result = url.match(/youtube\.com.*(\?v=|\/embed\/)(.{11})/);
                video_id = result.pop();
            } else if (url.match(/youtu.be\/(.{11})/)) {
                result = url.match(/youtu.be\/(.{11})/)
                video_id = result.pop();
            }

            if (video_id) {
                thumbnail = "https://img.youtube.com/vi/" + video_id + "/maxresdefault.jpg";
                return thumbnail;
            }
        }
        return '';
    }

    const onSubmit = async (data) => {
        let postData = { title: data?.title, description: data?.description, is_published: data?.is_published };

        if (typeof (data?.thumbnail_type) !== 'undefined') {
            postData = { ...postData, thumbnail_type: data?.thumbnail_type };

            if (data?.thumbnail_type === 'video') {
                if (data?.video_url !== '') {
                    let thumbnail_url = get_youtube_thumbnail(data?.video_url);
                    if (thumbnail_url !== '')
                        postData = { ...postData, thumbnail_url: thumbnail_url, video_url: data?.video_url };
                }
            }
        }

        let formData = new FormData();
        Object.keys(postData).map((key) => {
            formData.append(key, postData[key]);
            return true;
        });

        if (data?.category_ids?.length) {
            let i = 0;
            for (i in data?.category_ids) {
                formData.append("category[]", data?.category_ids[i]);
            }
        }

        if (data?.property_ids?.length) {
            let i = 0;
            for (i in data?.property_ids) {
                formData.append("properties[]", data?.property_ids[i]);
            }
        }

        if (thumbnailTemp) {
            formData.append("image", thumbnailTemp);
        }

        setLoading(true);
        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

        axios.post(process.env.REACT_APP_RESOURCE_API_URL + "v1/articles", formData, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }).then((response) => {
            setLoading(false);

            setSnackbarMsg(response.data.message);
            setSnackbarOpen(true);

            let logData = {
                'title': 'A new article has been added',
                'description': [
                    'Title: ' + response.data.data?.title,
                    'Categories: ' + response.data.data?.category_names.join(', '),
                    'Properties: ' + response.data.data?.property_names.join(', ')
                ]
            }
            AddLogCallAPI(logData, token);

            setTimeout(() => {
                redirect.push('/resources/knowledge-bases');
            }, 2000);
        }).catch((error) => {
            if (typeof error.response !== "undefined")
                toast.error(error.response.data.message);
            setLoading(false);
        });
    }

    const onUpdate = async (data) => {
        let postData = { title: data?.title, description: data?.description, is_published: data?.is_published };

        if (typeof (data?.thumbnail_type) !== 'undefined') {
            if (data?.thumbnail_type === 'video') {
                if (data?.video_url !== '') {
                    let thumbnail_url = get_youtube_thumbnail(data?.video_url);
                    if (thumbnail_url !== '')
                        postData = { ...postData, thumbnail_url: thumbnail_url, video_url: data?.video_url, thumbnail_type: data?.thumbnail_type };
                }
            } else {
                postData = { ...postData, thumbnail_type: data?.thumbnail_type };
            }
        }

        let formData = new FormData();
        Object.keys(postData).map((key) => {
            formData.append(key, postData[key]);
            return true;
        });

        if (data?.category_ids?.length) {
            let i = 0;
            for (i in data?.category_ids) {
                formData.append("category[]", data?.category_ids[i]);
            }
        }

        if (data?.property_ids?.length) {
            let i = 0;
            for (i in data?.property_ids) {
                formData.append("properties[]", data?.property_ids[i]);
            }
        }

        if (thumbnailTemp) {
            formData.append("image", thumbnailTemp);
        }

        setLoading(true);
        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

        axios.post(process.env.REACT_APP_RESOURCE_API_URL + "v1/articles/" + id, formData, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }).then((response) => {
            setLoading(false);

            setSnackbarMsg(response.data.message);
            setSnackbarOpen(true);

            let logData = {
                'title': 'Article has been updated',
                'description': [
                    'Title: ' + response.data.data?.title,
                    'Categories: ' + response.data.data?.category_names.join(', '),
                    'Properties: ' + response.data.data?.property_names.join(', ')
                ]
            }
            AddLogCallAPI(logData, token);

            setTimeout(() => {
                redirect.push('/resources/knowledge-bases');
            }, 2000);
        }).catch((error) => {
            if (typeof error.response !== "undefined")
                toast.error(error.response.data.message);
            setLoading(false);
        });
    }

    const fileHandler = (e) => {
        var validExtensions = ["jpg", "jpeg", "png"];
        var fileName = e.target.files[0].name;
        var fileNameExt = fileName.substr(fileName.lastIndexOf(".") + 1);
        if (validExtensions.indexOf(fileNameExt.toLowerCase()) === -1) {
            toast.error("File type is not allowed");
        } else if (e.target.files[0].size > 1048576) {
            toast.error("Image size should not be greater than 5 mb.");
        } else {
            let file = e.target.files[0];

            setThumbnailTemp(file)
            setThumbnailTempURL(URL.createObjectURL(file));
            setValue('image_url', URL.createObjectURL(file));
            clearErrors();
        }
    }

    return (<>
        {loading && <Loader />}
        <Helmet title={id ? "Update Knowledge Base" : "Add Knowledge Base"} />
        <div className={`${styles.mainCard}`}>
            <div className={`${styles.SMProCusRow}`}>
                <div className={`${styles.BreadcrumbHeadSec}`}>
                    <nav aria-label="breadcrumb">
                        <ol className={`${styles.breadcrumb}`}>
                            <li className={`${styles.breadcrumbItem}`}><span><Home /></span>{" "}Resources</li>
                            <li className={`${styles.breadcrumbItem}`}>Knowledge Base</li>
                            <li className={`${styles.breadcrumbItem} ${styles.active}`}>{id ? "Update" : "Add"}</li>
                        </ol>
                    </nav>
                    <div className={`${styles.PageTitleSec}`}>
                        <div>
                            <Link to={`/resources/knowledge-bases`} className={`${styles.BackArrow}`}><ArrowLeft /></Link>
                            <Typography display="inline" className={`${styles.pageTitle}`}>Knowledge Base</Typography>
                        </div>
                    </div>
                </div>

                <div className={`${styles.ExpensesAddMainSec}`}>
                    <form onSubmit={handleSubmit(id ? onUpdate : onSubmit)}>
                        <div className={`${styles.AddArticleRow}`}>
                            <div className={`${styles.AddArticleBigSec}`}>
                                <div className={`${styles.FormGroupTextareaFull}`}>
                                    {/* <label className={`${styles.FilterLabel}`}>Title & Description<span className={`${styles.errorSpan}`}>*</span></label> */}
                                    <Controller
                                        name="description"
                                        control={control}
                                        render={(field) => (
                                            <Editor
                                                onInit={(evt, editor) => { editorRef.current = editor }}
                                                className={`${styles.formControlTextArea}`}
                                                apiKey={process.env.REACT_APP_TINYMCE_API_KEY}
                                                value={field?.value}
                                                init={{
                                                    height: 600,
                                                    menubar: false,
                                                    popup_css: false,
                                                    plugins: "lists media mediaembed image",
                                                    toolbar: "undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | forecolor backcolor removeformat | alignleft aligncenter alignright alignjustify | numlist bullist |  fullscreen  | ltr rtl | customImage media",
                                                    content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:16px }',
                                                    automatic_uploads: true,
                                                    file_picker_types: 'image',
                                                    file_picker_callback: (cb, value, meta) => {
                                                        const input = document.createElement('input');
                                                        input.setAttribute('type', 'file');
                                                        input.setAttribute('accept', 'image/*');

                                                        input.addEventListener('change', (e) => {
                                                            const file = e.target.files[0];

                                                            const reader = new FileReader();
                                                            reader.addEventListener('load', () => {
                                                                const id = 'blobid' + new Date().getTime();
                                                                const blobCache = editorRef.current.editorUpload.blobCache;
                                                                const base64 = reader.result.split(',')[1];
                                                                const blobInfo = blobCache.create(id, file, base64);
                                                                blobCache.add(blobInfo);

                                                                cb(blobInfo.blobUri(), { title: file.name });
                                                            });
                                                            reader.readAsDataURL(file);
                                                        });

                                                        input.click();
                                                    },
                                                    setup: (editor) => {
                                                        editor.ui.registry.addButton('customImage', {
                                                            icon: 'image',
                                                            tooltip: 'Insert/edit image',
                                                            onAction: () => {
                                                                //setModalDisplay(false);
                                                                editor.execCommand('mceImage'); // may still work in some cases
                                                            },
                                                        });
                                                    }
                                                }}
                                                onEditorChange={(e) => field.onChange(e)}
                                            />
                                        )}
                                    />
                                    {errors.description && (<p className={`${styles.ErrorM}`}>{errors.description.message}</p>)}
                                </div>
                            </div>
                            <div className={`${styles.AddArticleSmallSec}`}>
                                <div className={`${styles.AddDocTitleSec}`}>
                                    <div className={`${styles.FormGroupAddLease} FormGroup`}>
                                        <FormControl sx={{ m: 1, width: 300 }}>
                                            <InputLabel id="demo-multiple-chip-label">Status*</InputLabel>
                                            <Controller
                                                name="is_published"
                                                control={control}
                                                render={(field) => (
                                                    <Select
                                                        {...field}
                                                        labelId="demo-multiple-chip-label"
                                                        id="demo-multiple-chip"
                                                        label={"Status*"}
                                                        onChange={(e) => {
                                                            field.onChange(e);
                                                            setIsPublished(e.target.value);
                                                        }}
                                                    >
                                                        <MenuItem value={0}>Draft</MenuItem>
                                                        <MenuItem value={1}>Publish</MenuItem>
                                                    </Select>)}
                                            />
                                        </FormControl>
                                        {errors.is_published && (<p className={`${styles.ErrorM}`}>{errors.is_published.message}</p>)}
                                    </div>
                                </div>
                                <div className={`${styles.AddDocTitleSec}`}>
                                    <div className={`${styles.FormGroupAddLease} FormGroup`}>
                                        <FormControl sx={{ m: 1, width: 300 }}>
                                            <InputLabel id="demo-multiple-chip-label">Property*</InputLabel>
                                            <Controller
                                                name="property_ids"
                                                control={control}
                                                render={(field) => (
                                                    <Select
                                                        labelId="demo-multiple-chip-label"
                                                        id="demo-multiple-chip"
                                                        multiple
                                                        value={selectedProperties}
                                                        onChange={(e) => {
                                                            setSelectedProperties(typeof e.target.value === 'string' ? e.target.value.split(',') : e.target.value);
                                                            setValue("property_ids", e.target.value);
                                                        }}
                                                        input={<OutlinedInput id="select-multiple-chip" label="Property*" />}
                                                        renderValue={(selected) => {
                                                            return <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                                                {propertyList.map((value) => {
                                                                    return selected?.indexOf(value?.id) > -1 ? <Chip key={value?.id} label={value?.name} /> : null;
                                                                })}
                                                            </Box>
                                                        }}
                                                        MenuProps={MenuProps}
                                                    >
                                                        {propertyList.map((item) => (
                                                            <MenuItem key={item?.id} value={item?.id}>
                                                                <Checkbox checked={selectedProperties.indexOf(item.id) > -1} />
                                                                <ListItemText primary={item.name} />
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                )}
                                            />
                                        </FormControl>
                                        {errors.property_ids && (<p className={`${styles.ErrorM}`}>{errors.property_ids.message}</p>)}
                                    </div>
                                </div>
                                <div className={`${styles.AddDocTitleSec}`}>
                                    <div className={`${styles.FormGroupAddLease} FormGroup`}>
                                        <Controller
                                            name={`title`}
                                            control={control}
                                            render={(field) => (<TextField {...field} id="outlined-basic" label="Knowledge Base Title*" variant="outlined" />)}
                                        />
                                        {errors.title && (<p className={`${styles.ErrorM}`}>{errors?.title?.message}</p>)}
                                    </div>
                                </div>
                                <div className={`${styles.AddDocTitleSec}`}>
                                    <div className={`${styles.FormGroupAddLease} FormGroup`}>
                                        <FormControl sx={{ m: 1, width: 300 }}>
                                            <InputLabel id="demo-multiple-chip-label">Category*</InputLabel>
                                            <Controller
                                                name="category_ids"
                                                control={control}
                                                render={(field) => (
                                                    <Select
                                                        labelId="demo-multiple-chip-label"
                                                        id="demo-multiple-chip"
                                                        multiple
                                                        value={selectedCategories}
                                                        onChange={(e) => {
                                                            setSelectedCategories(typeof e.target.value === 'string' ? e.target.value.split(',') : e.target.value);
                                                            setValue("category_ids", e.target.value);
                                                        }}
                                                        input={<OutlinedInput id="select-multiple-chip" label="Category*" />}
                                                        renderValue={(selected) => {
                                                            return <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                                                {categoryList.map((value) => {
                                                                    return selected?.indexOf(value?.id) > -1 ? <Chip key={value?.id} label={value?.title} /> : null;
                                                                })}
                                                            </Box>
                                                        }}
                                                        MenuProps={MenuProps}
                                                    >
                                                        {categoryList.map((item) => (
                                                            <MenuItem key={item?.id} value={item?.id}>
                                                                <Checkbox checked={selectedCategories.indexOf(item.id) > -1} />
                                                                <ListItemText primary={item.title} />
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                )}
                                            />
                                        </FormControl>
                                        {errors.category_ids && (<p className={`${styles.ErrorM}`}>{errors.category_ids.message}</p>)}
                                    </div>
                                </div>
                                <div className={`${styles.AddDocTitleSec}`}>
                                    <div className={`${styles.FormGroupAddLease} FormGroup`}>
                                        <FormControl sx={{ m: 1, width: 300 }}>
                                            <InputLabel id="demo-multiple-chip-label">Thumbnail for article list on device</InputLabel>
                                            <Controller
                                                name="thumbnail_type"
                                                control={control}
                                                render={(field) => (
                                                    <Select
                                                        {...field}
                                                        labelId="demo-multiple-chip-label"
                                                        id="demo-multiple-chip"
                                                        label={"Thumbnail for article list on device"}
                                                        onChange={(e) => {
                                                            field.onChange(e);

                                                            setThumbnailType(e.target.value);
                                                            setThumbnailTempURL("");

                                                            setValue('video_url', '');
                                                            setValue('image_url', '');
                                                        }}
                                                    >
                                                        <MenuItem value={"video"}>Youtube Poster</MenuItem>
                                                        <MenuItem value={"image"}>Upload Image</MenuItem>
                                                    </Select>
                                                )}
                                            />
                                        </FormControl>
                                        {errors.thumbnail_type && (<p className={`${styles.ErrorM}`}>{errors?.thumbnail_type?.message}</p>)}
                                    </div>
                                </div>
                                {thumbnailType === 'video' && <div className={`${styles.AddDocTitleSec}`}>
                                    <div className={`${styles.FormGroupAddLease} FormGroup`}>
                                        <Controller
                                            name={`video_url`}
                                            control={control}
                                            render={(field) => (<TextField {...field} id="outlined-basic" label="Youtube URL for Thumbnail Poster*" variant="outlined" />)}
                                        />
                                        {errors.video_url && (<p className={`${styles.ErrorM}`}>{errors?.video_url?.message}</p>)}
                                    </div>
                                </div>}
                                {thumbnailType === 'image' && <div className={`${styles.AddDocTitleSec}`}>
                                    <div className={`${styles.FormGroupAddLease} FormGroup`}>
                                        <input type="text" {...register('image_url')} className={`${styles.Invisible}`} />
                                        <label className={`${styles.TakePhoteBU}`} for="file-upload"><UploadCloud /> Upload Thumbnail</label>
                                        <p className={`${styles.UploadTextNew}`}>File size upto 1 MB. JPEG, JPG, PNG only. <br />Dimension is 260 X 140</p>
                                        <div className={`${styles.FileIMGDiv}`}>
                                            {thumbnailTempURL === "" && thumbnailURL === "" && <div className={`${styles.FileUpDuBUDiv}`}>
                                                <input id="file-upload" type="file" onChange={fileHandler} accept=".jpg,.png,.jpeg" inputProps={{ accept: "image/*" }} />
                                            </div>}
                                            <div className={`${styles.UpIMGSec}`}>
                                                {thumbnailURL !== '' && thumbnailTempURL === '' && <div className={`${styles.ImgFile}`}>
                                                    <img src={thumbnailURL} alt="" width={'200px'} />
                                                    <Button onClick={(e) => { setThumbnailURL(""); setValue('image_url', ''); }}><X /></Button>
                                                </div>}
                                                {thumbnailTempURL !== '' && <div className={`${styles.ImgFile}`}>
                                                    <img src={thumbnailTempURL} alt="" width={'200px'} />
                                                    <Button onClick={(e) => { setThumbnailTempURL(""); setValue('image_url', ''); }}><X /></Button>
                                                </div>}
                                            </div>
                                        </div>
                                        {errors.image_url && (<p className={`${styles.ErrorM}`}>{errors?.image_url?.message}</p>)}
                                    </div>
                                </div>}
                                <div className={`${styles.ButtonAction}`}>
                                    <Link to={`/resources/knowledge-bases`} className={`${styles.CancelPopupBU}`}>Cancel</Link>
                                    <Button className={`${styles.SubmitPopupBU}`} type="submit">{isPublished ? "Publish" : "Save Draft"}</Button>
                                </div>
                            </div>

                        </div>
                    </form>
                </div>
            </div>
        </div>

        <Snackbar
            open={snackbarOpen}
            onClose={(e) => setSnackbarOpen(false)}
            TransitionComponent={Slide}
            message={snackbarMsg}
            autoHideDuration={10000}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            action={
                <IconButton
                    size="small"
                    aria-label="close"
                    color="inherit"
                    onClick={(e) => setSnackbarOpen(false)}
                >
                    <X />
                </IconButton>
            }
        />

    </>);
};

export default AddArticle;